(() => {
  document.documentElement.classList.add('td-js');
  const reduce = () => matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* Shipping dates: order today, shipped +2, delivered +7 to +10 calendar days, local time. */
  function fmtRange(now, start, end, locale) {
    const day = (n) => new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12);
    const a = day(start), b = day(Math.max(start, end));
    const opts = { month: 'short', day: 'numeric' };
    if (b.getFullYear() !== now.getFullYear()) opts.year = 'numeric';
    const f = new Intl.DateTimeFormat(locale, opts);
    let text;
    if (start === end) text = f.format(a);
    else if (f.formatRange) text = f.formatRange(a, b);
    else text = f.format(a) + '–' + f.format(b);
    return { a, b, text };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(), loc = document.documentElement.lang || 'en-US';
    document.querySelectorAll('[data-td-ship-date]').forEach((el) => {
      const s = Number(el.dataset.start), e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      try {
        const r = fmtRange(now, s, e, loc);
        el.textContent = r.text;
        const full = new Intl.DateTimeFormat(loc, { dateStyle: 'long' });
        el.setAttribute('aria-label', s === e ? full.format(r.a) : full.format(r.a) + ' to ' + full.format(r.b));
      } catch (x) {}
    });
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  window.addEventListener('pageshow', updateShipDates);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateShipDates(); });

  /* Cart reconcile: free gift line + discount codes that belong to this page. */
  const Sync = (() => {
    let cfg = null, pending = null;
    const base = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    async function req(path, body, tries = 2) {
      const r = await fetch(base() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
      let d;
      try { d = JSON.parse(await r.text()); } catch (e) {
        if (tries > 1) { await new Promise((z) => setTimeout(z, 500)); return req(path, body, tries - 1); }
        throw Error('Your cart is busy. Please try again in a moment.');
      }
      if (!r.ok || d.status) throw Error(d.description || d.message || 'Your cart could not be updated. Please try again.');
      return d;
    }
    async function reconcile() {
      if (!cfg) return null;
      let cart = await req('cart.js');
      const has = (ids) => cart.items.some((i) => ids.includes(Number(i.variant_id)));
      const seat = has(cfg.seats);
      const gifts = cart.items.filter((i) => Number(i.variant_id) === cfg.gift);
      const wantGift = seat && cfg.gift ? 1 : 0;
      const haveGift = gifts.reduce((n, i) => n + i.quantity, 0);
      const wantCodes = [];
      if (seat && cfg.giftCode) wantCodes.push(cfg.giftCode);
      cfg.addons.forEach((a) => { if (seat && a.code && has([a.variant])) wantCodes.push(a.code); });
      const ownAll = [cfg.giftCode, ...cfg.addons.map((a) => a.code)].filter(Boolean).map((c) => c.toUpperCase());
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const others = codes.filter((c) => !ownAll.includes(c.toUpperCase()));
      const haveOwn = codes.filter((c) => ownAll.includes(c.toUpperCase())).map((c) => c.toUpperCase()).sort().join(',');
      const wantOwn = wantCodes.map((c) => c.toUpperCase()).sort().join(',');
      const giftFree = gifts.every((i) => i.final_line_price === 0);
      if (haveGift === wantGift && haveOwn === wantOwn && (wantGift === 0 || giftFree)) return cart;
      const updates = {};
      if (gifts.length) gifts.forEach((g, k) => (updates[g.key] = k === 0 ? wantGift : 0));
      else if (wantGift) updates[cfg.gift] = wantGift;
      const drawer = document.querySelector('cart-drawer');
      const sections = (drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender().map((s) => s.id) : [];
      cart = await req('cart/update.js', { updates, discount: [...others, ...wantCodes].join(','), sections, sections_url: location.pathname });
      const charged = cart.items.filter((i) => Number(i.variant_id) === cfg.gift && i.final_line_price > 0);
      if (wantGift && charged.length) {
        const rm = {};
        charged.forEach((i) => (rm[i.key] = 0));
        cart = await req('cart/update.js', { updates: rm, sections, sections_url: location.pathname });
        if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
        throw Error('Your seat is in your cart, but the free magic targets could not be applied. Please contact us before checkout.');
      }
      if (drawer && drawer.renderContents && cart.sections) drawer.renderContents({ id: cfg.gift, sections: cart.sections });
      return cart;
    }
    return {
      set(c) { cfg = c; },
      sync() { if (!pending) pending = reconcile().finally(() => (pending = null)); return pending; },
    };
  })();
  window.TadaSync = Sync;

  function initReveal() {
    const secs = document.querySelectorAll('.td-s[data-td-reveal]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      secs.forEach((s) => io.observe(s));
    } else secs.forEach((s) => s.classList.add('is-in'));
    const catchUp = () => secs.forEach((s) => { if (s.getBoundingClientRect().top < innerHeight) s.classList.add('is-in'); });
    addEventListener('scroll', () => requestAnimationFrame(catchUp), { passive: true });
    catchUp();
  }

  function init() {
    updateShipDates();
    initReveal();
    const root = document.querySelector('#tada');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.td-proof .ceyla-rproof__text').forEach((p) => p.childNodes.forEach((n) => { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; }));

    const money = (c) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(c / 100);
    const short = (c) => money(c).replace(/\.00(?=\D*$)/, '');
    const swatches = [...root.querySelectorAll('.td-sw')];
    const seatRadios = [...root.querySelectorAll('[name="td-seat"]')];
    const planRadios = [...root.querySelectorAll('[name="td-plan"]')];
    const addons = [...root.querySelectorAll('[data-td-addon]')].map((el) => ({ el, idx: el.dataset.tdAddon, variant: Number(el.dataset.variant), price: Number(el.dataset.price) })).filter((a) => a.variant);
    const kitOff = Number(root.dataset.kitOff || 0);
    const kitCodes = (root.dataset.kitCodes || '').split('|');
    Sync.set({
      seats: swatches.map((b) => Number(b.dataset.variant)),
      gift: Number(root.dataset.giftVariant) || 0,
      giftCode: root.dataset.giftCode || '',
      addons: addons.map((a) => ({ variant: a.variant, code: kitCodes[Number(a.idx) - 1] || '' })),
    });

    /* Gallery */
    const g = root.querySelector('[data-td-gallery]');
    const slides = [...g.querySelectorAll('.td-slide')];
    const thumbs = [...root.querySelectorAll('.td-thumb')];
    const smooth = () => (reduce() ? 'auto' : 'smooth');
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : g.clientWidth) || g.clientWidth;
    const idx = () => Math.max(0, Math.min(slides.length - 1, Math.round(g.scrollLeft / step())));
    const to = (i, instant) => g.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * step(), behavior: instant ? 'auto' : smooth() });
    root.querySelectorAll('[data-td-slide]').forEach((b) => b.addEventListener('click', () => to(Number(b.dataset.tdSlide))));
    const nx = root.querySelector('[data-td-next]'), pv = root.querySelector('[data-td-prev]');
    nx && nx.addEventListener('click', () => to(idx() + 1));
    pv && pv.addEventListener('click', () => to(idx() - 1));
    let raf;
    g.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = idx(), ix = root.querySelector('[data-td-index]');
        if (ix) ix.textContent = String(i + 1);
        thumbs.forEach((t, j) => { t.classList.toggle('is-on', i === j); t.setAttribute('aria-pressed', String(i === j)); });
      });
    }, { passive: true });
    g.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); to(idx() + (e.key === 'ArrowRight' ? 1 : -1)); } });

    /* State */
    let current = swatches.find((b) => b.classList.contains('is-on')) || swatches[0];
    let plan = Number(root.dataset.plan) || 3;
    const urlV = new URL(location.href).searchParams.get('variant');
    if (urlV) { const m = swatches.find((b) => b.dataset.variant === urlV); if (m) current = m; }
    const termsId = root.querySelector('[data-td-terms-id]');
    const planAddons = (p) => addons.filter((a) => (p >= 2 && a.idx === '1') || (p >= 3 && a.idx === '2'));
    const totals = (p) => {
      const price = Number(current.dataset.price), compare = Number(current.dataset.compare) || price;
      const ads = planAddons(p);
      const total = price + ads.reduce((n, a) => n + a.price - kitOff, 0);
      const full = compare + ads.reduce((n, a) => n + a.price, 0);
      return { total, full, save: full - total, kitSave: ads.length * kitOff };
    };

    function paint(fromUser, popPlan) {
      const seat = current.dataset.seat;
      seatRadios.forEach((r) => { r.checked = r.value === seat; r.closest('.td-seat').classList.toggle('is-on', r.checked); });
      swatches.forEach((b) => {
        const on = b === current;
        b.hidden = b.dataset.seat !== seat;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', String(on));
      });
      const isLadder = seatRadios[0] && seat === seatRadios[0].value;
      const sh = root.querySelector('[data-td-style-h]');
      if (sh) sh.textContent = isLadder ? 'Color' : 'Toilet size';
      const sn = root.querySelector('[data-td-style-name]');
      if (sn) sn.textContent = current.dataset.style;
      const help = root.querySelector('[data-td-size-help]');
      if (help) help.hidden = isLadder;
      root.querySelectorAll('[data-td-seat-thumb]').forEach((img) => { if (current.dataset.thumb) img.src = current.dataset.thumb; });
      planRadios.forEach((r) => {
        const n = Number(r.value), t = totals(n);
        r.checked = n === plan;
        const card = r.closest('.td-plan');
        card.classList.toggle('is-on', r.checked);
        const ps = root.querySelector('[data-td-plan-price="' + n + '"]'), pc = root.querySelector('[data-td-plan-compare="' + n + '"]'), pss = root.querySelector('[data-td-plan-save="' + n + '"]');
        if (ps) ps.textContent = money(t.total);
        if (pc) pc.textContent = t.full > t.total ? money(t.full) : '';
        if (pss) pss.textContent = t.save > 0 ? 'You save ' + short(t.save) : '';
        if (popPlan && n === plan && !reduce()) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      });
      const t = totals(plan);
      root.querySelector('[data-td-price]').textContent = money(t.total);
      const c = root.querySelector('[data-td-compare]'), sv = root.querySelector('[data-td-save]');
      if (t.full > t.total) { c.hidden = false; sv.hidden = false; c.textContent = money(t.full); sv.textContent = 'Save ' + short(t.save); } else { c.hidden = true; sv.hidden = true; }
      document.querySelectorAll('[data-td-atc-total]').forEach((el) => (el.textContent = money(t.total)));
      const sp = document.querySelector('[data-td-sticky-price]');
      if (sp) sp.textContent = money(t.total) + ' · ' + current.dataset.style;
      if (termsId && termsId.value !== current.dataset.variant) { termsId.value = current.dataset.variant; termsId.dispatchEvent(new Event('change', { bubbles: true })); }
      document.querySelectorAll('[data-td-kit-toggle]').forEach((b) => {
        const on = b.dataset.tdKitToggle === '1' ? plan >= 2 : plan >= 3;
        b.setAttribute('aria-pressed', String(on));
        const s2 = b.querySelector('span');
        if (s2) s2.textContent = on ? s2.dataset.on : s2.dataset.off;
      });
      const avail = current.dataset.available !== 'false';
      document.querySelectorAll('[data-td-add]').forEach((b) => { if (!b.getAttribute('aria-busy')) b.disabled = !avail; });
      if (fromUser) {
        const u = new URL(location.href);
        u.searchParams.set('variant', current.dataset.variant);
        history.replaceState(history.state, '', u);
        const mid = current.dataset.media;
        if (mid) { const si = slides.findIndex((sl) => sl.dataset.mediaId === mid); if (si >= 0 && root.querySelector('.td-buy').getBoundingClientRect().top < innerHeight) to(si); }
      }
    }
    seatRadios.forEach((r) => r.addEventListener('change', () => {
      const keepStyle = swatches.find((b) => b.dataset.seat === r.value);
      if (keepStyle) current = keepStyle;
      paint(true, false);
    }));
    swatches.forEach((b) => b.addEventListener('click', () => { current = b; paint(true, false); }));
    planRadios.forEach((r) => r.addEventListener('change', () => { plan = Number(r.value); paint(false, true); }));
    document.querySelectorAll('[data-td-kit-toggle]').forEach((b) => b.addEventListener('click', () => {
      const i = b.dataset.tdKitToggle;
      if (i === '1') plan = plan >= 2 ? 1 : 2;
      else plan = plan >= 3 ? 2 : 3;
      paint(false, true);
    }));
    paint(false, false);
    window.addEventListener('pageshow', () => paint(false, false));

    /* Native drawer */
    async function drawerReady() {
      await customElements.whenDefined('cart-drawer');
      const d = document.querySelector('cart-drawer');
      if (!d || typeof d.renderContents !== 'function') throw Error('The cart is still loading. Please try again.');
      return d;
    }
    const setCount = (n) => root.querySelectorAll('[data-td-count]').forEach((e) => (e.textContent = n));
    const vipFirst = () => {
      const sheet = document.querySelector('.vf-root'), bag = document.querySelector('cart-drawer');
      if (!sheet || !bag || sheet.classList.contains('open')) return;
      const hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
      Object.keys(hide).forEach((p) => bag.style.setProperty(p, hide[p], 'important'));
      let ticks = 0;
      const tm = setInterval(() => { if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach((p) => bag.style.removeProperty(p)); } }, 100);
    };
    let busy = false;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget;
      if (current.dataset.available === 'false') return;
      busy = true;
      const buttons = [...document.querySelectorAll('[data-td-add]')];
      buttons.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const err = root.querySelector('[data-td-error]');
      err.textContent = '';
      try {
        const drawer = await drawerReady();
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map((s) => s.id);
        const items = [{ id: Number(current.dataset.variant), quantity: 1 }];
        planAddons(plan).forEach((a) => items.push({ id: a.variant, quantity: 1 }));
        const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections, sections_url: location.pathname }) });
        let data;
        try { data = JSON.parse(await res.text()); } catch (x) { throw Error('Your seat could not be added. Please try again.'); }
        if (!res.ok || data.status) throw Error(data.description || data.message || 'Your seat could not be added. Please try again.');
        vipFirst();
        drawer.renderContents(data);
        let cart;
        try { cart = await Sync.sync(); } catch (ge) { err.textContent = ge.message; }
        if (!cart) cart = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        setCount(cart.item_count);
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        drawer.open(btn);
      } catch (x) {
        err.textContent = x.message || 'Please check your cart before trying again.';
        err.scrollIntoView({ block: 'center', behavior: smooth() });
      } finally {
        busy = false;
        buttons.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; });
        paint(false, false);
      }
    }
    document.querySelectorAll('[data-td-add]').forEach((b) => b.addEventListener('click', add));
    root.querySelectorAll('[data-td-cart]').forEach((b) => b.addEventListener('click', async () => {
      try {
        const d = await drawerReady();
        await Sync.sync();
        const ids = d.getSectionsToRender().map((s) => s.id), base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const [sections, c] = await Promise.all([fetch(base + '?sections=' + ids.join(',')).then((r) => r.json()).catch(() => null), fetch(base + 'cart.js').then((r) => r.json())]);
        if (sections) d.renderContents({ id: 0, sections });
        d.classList.toggle('is-empty', c.item_count === 0);
        setCount(c.item_count);
        d.open(b);
      } catch (x) { root.querySelector('[data-td-error]').textContent = x.message; }
    }));
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(window.__tdSync);
        window.__tdSync = setTimeout(() => Sync.sync().then((c) => c && setCount(c.item_count)).catch((x) => {
          const e = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-td-error]');
          if (e) e.textContent = x.message;
        }), 150);
      });
    }
    const nd = document.querySelector('cart-drawer');
    if (nd) new MutationObserver(() => {
      const q = [...nd.querySelectorAll('.cart-drawer-item .quantity__input')];
      if (q.length) setCount(q.reduce((n, i) => n + Number(i.value || 0), 0));
      else if (nd.classList.contains('is-empty')) setCount(0);
    }).observe(nd, { subtree: true, childList: true });
    document.addEventListener('click', (e) => {
      const b = e.target.closest('cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.tdReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      Sync.sync().then(() => {
        const n = document.querySelector('cart-drawer [name="checkout"]') || b;
        n.dataset.tdReady = '1'; n.click(); delete n.dataset.tdReady;
      }).catch((x) => { const el = document.querySelector('#CartDrawer-CartErrors') || root.querySelector('[data-td-error]'); if (el) el.textContent = x.message; });
    }, true);
    Sync.sync().then((c) => c && setCount(c.item_count)).catch(() => {});

    const dlg = document.querySelector('#tada-policy');
    if (dlg) {
      document.querySelectorAll('[data-td-policy]').forEach((b) => b.addEventListener('click', () => dlg.showModal()));
      dlg.querySelector('[data-td-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
    const cBan = document.querySelector('.td-banner'), cPill = document.querySelector('.td-concept-pill');
    if (cPill) {
      if (cBan && 'IntersectionObserver' in window) new IntersectionObserver((es) => cPill.classList.toggle('is-on', !es[0].isIntersecting)).observe(cBan);
      else cPill.classList.add('is-on');
    }
    const sticky = document.querySelector('[data-td-sticky]'), buy = root.querySelector('.td-buy .td-atc');
    if (sticky && buy) {
      let sraf;
      const check = () => {
        cancelAnimationFrame(sraf);
        sraf = requestAnimationFrame(() => {
          const show = buy.getBoundingClientRect().bottom < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelector('button').tabIndex = show ? 0 : -1;
        });
      };
      addEventListener('scroll', check, { passive: true });
      addEventListener('resize', check);
      check();
    }
  }

  function widgets() {
    document.querySelectorAll('[data-td-fit]').forEach((f) => {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      const tabs = [...f.querySelectorAll('[data-fit-tab]')], panes = [...f.querySelectorAll('[data-fit-pane]')];
      tabs.forEach((b) => b.addEventListener('click', () => {
        tabs.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', String(on)); });
        panes.forEach((p) => (p.hidden = p.dataset.fitPane !== b.dataset.fitTab));
      }));
      const r = f.querySelector('[data-fit-range]'), out = f.querySelector('[data-fit-out]'), pick = f.querySelector('[data-fit-pick]'), why = f.querySelector('[data-fit-why]');
      const txt = {};
      const tpl = f.querySelector('[data-fit-text]');
      if (tpl) tpl.content.querySelectorAll('[data-k]').forEach((s) => (txt[s.dataset.k] = s.textContent));
      if (r) {
        const set = () => {
          const v = Number(r.value);
          out.textContent = v.toFixed(1) + ' in';
          const long = v >= 17.5;
          pick.textContent = long ? txt.long_label : txt.round_label;
          why.textContent = long ? txt.long_answer : txt.round_answer;
        };
        r.addEventListener('input', set); set();
      }
    });
  }

  const boot = () => { init(); widgets(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => { updateShipDates(); widgets(); document.querySelectorAll('.td-s[data-td-reveal]').forEach((s) => s.classList.add('is-in')); });
})();
